import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import {
  LocalLogo,
  LocalsearchLogo,
  LocalChristmasLogo,
  LocalsearchChristmasLogo,
  LocalEasterLogo,
  LocalsearchEasterLogo,
  LocalAnzacLogo,
  LocalsearchAnzacLogo,
} from '../../../assets/localsearchLogo';
import './styles.css';

const Logo = ({ small, christmas, easter, anzac, mobile }) => {
  const localsearchLogo = useMemo(() => {
    if (christmas) return <LocalsearchChristmasLogo width={139} height={42} />;
    if (easter) return <LocalsearchEasterLogo width={139} height={42} />;
    if (anzac)
      return mobile ? (
        <LocalsearchAnzacLogo width={113} height={34} />
      ) : (
        <LocalsearchAnzacLogo width={139} height={42} />
      );
    return <LocalsearchLogo />;
  }, [christmas, easter, anzac, mobile]);

  const localLogo = useMemo(() => {
    if (christmas) return <LocalChristmasLogo width={50} />;
    if (easter) return <LocalEasterLogo width={50} />;
    if (anzac) return <LocalAnzacLogo width={65} height={36} />;
    return <LocalLogo width={47} />;
  }, [christmas, easter, anzac]);

  return (
    <div
      className={classNames('Header__Logo__root', {
        'Header__Logo--christmas': christmas,
        'Header__Logo--anzac': anzac,
        'Header__Logo--easter': easter,
        'Header__Logo--small': small,
      })}
    >
      <Link to="/" aria-label="back to home">
        {small ? localLogo : localsearchLogo}
      </Link>
    </div>
  );
};

export default Logo;
